<template>
  <div class="icon-container">
    <slot class="slot"></slot>
    <i class="iconfont" :class="fontClass"></i>
  </div>
</template>

<script>
const classMap = {
  shouye: "icon-shouye",
  error: "icon-cuowu",
  up: "icon-xiangshang",
  down: "icon-xiangxia",
  weixin: "icon-weixin",
  warn: "icon-jinggao",
  write: "icon-blog",
  liuyan: "icon-liuyan",
  info: "icon-xinxi",
  success: "icon-zhengque",
  code: "icon-code",
  QQ: "icon-QQ",
  "github-fill": "icon-github-fill",
  // close: "icon-guanbi",
  about: "icon-about",
  empty: "icon-empty",
  "email-fill": "icon-email-fill",
  fabu: "icon-fabu",
  daochu: "icon-daochu",
  lastpage: "icon-firstpage",
  firstpage: "icon-first",
  left: "icon-xiangzuo",
  right: "icon-xiangyou",
  fenye: "icon-fenye",
  dingxiang: "icon-dingxiang",
  xiangmu: "icon-xiangmu",
  thirty: "icon-thirty",
  "a-30fenzhong": "icon-a-30fenzhong",
  search: "icon-sousuo",
  resume: "icon-wodejianli",
  blog: "icon-boke",
  close: "icon-close",
};
export const types = Object.keys(classMap);
export default {
  props: {
    type: {
      type: String,
      require: true,
    },
  },
  computed: {
    fontClass() {
      return classMap[this.type];
    },
  },
};
</script>

<style lang="less" scoped>
@import "//at.alicdn.com/t/c/font_2811565_ugphb5jy0cg.css";
.iconfont {
  font-size: inherit;
  color: inherit;
}
</style>
